/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2026 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import mapObj from "map-obj";
import camelcase from "lodash.camelcase";
import snakecase from "lodash.snakecase";

const TO_MAPPING: Record<string, string> = {
  assetId: "trackId",
};

export function mapToServerFormat(data: Record<string, any>): Object {
  return mapObj(
    data,
    (key, value) => {
      return [snakecase(TO_MAPPING[key] ?? key), value];
    },
    { deep: true }
  );
}

const FROM_MAPPING: Record<string, string> = {
  track_id: "asset_id",
  download_url: "url",
};

const CAMEL_CASE_EXCEPTIONS: Record<string, string> = {
  // Lodash.camelcase treats number sequences as word boundaries :(
  sl4WEsqaEnabled: "sl4wEsqaEnabled",
  sl4WStudioEnabled: "sl4wStudioEnabled",
};

const camelcaseWithExceptions = (key: string): string => {
  const camelCasedKey = camelcase(FROM_MAPPING[key] ?? key);
  return CAMEL_CASE_EXCEPTIONS[camelCasedKey] ?? camelCasedKey;
};

export function mapFromServerFormat(
  data: Record<string, any>
): Record<string, any> {
  return mapObj(
    data,
    (key, value) => {
      const camelCasedKey = camelcaseWithExceptions(key);
      return [camelCasedKey, value];
    },
    { deep: true }
  );
}
